module.exports = __webpack_public_path__ + "background5.jpg?d4e35b1f48599b708ceccd2f78973f7c";